import { Link } from "react-router-dom";

const Terms = () => {
  return (
    <div className="policy terms container">
      <h1>
        Rexla Terms of Service <span>V1.1 19th January 2025</span>
      </h1>
      <p>
        Rexla Global (“<b>Rexla</b>,” “<b>us</b>,” “<b>we</b>,” or “<b>our</b>”)
        provides the “<b>Rexla Hub</b>” and associated products (located at
        Rexla.com) to allow users to onboard and learn about Digital/Crypto
        Assets, obtain education on the space and act as a hub for individuals
        to interact with blockchain technology. This includes mobile
        applications and the blockchain currency management software that is
        downloadable from our website (the “<b>Rexla Wallet</b>”), and the Digi
        Dimes Rewards Program (“<b>Rewards Program</b>”), collectively the “
        <b>Services</b>”. This document provides you with information on the
        basis for your interaction with, and the provision of our suite of
        services.
      </p>
      <p>
        These Terms do not govern any interactions you may with our third-party
        API providers, each of which has its own terms. Rexla is not a bank or
        financial institution and does not provide investment or financial
        advice to users of the Services. We are solely the provider of the
        Services, and do not at any stage act as Custodians for your assets.
      </p>

      <p>
        <b>
          IMPORTANT NOTICE REGARDING ARBITRATION: WHEN YOU AGREE TO THESE TERMS
          YOU ARE AGREEING (WITH LIMITED EXCEPTION) TO RESOLVE ANY DISPUTE
          BETWEEN YOU AND REXLA GLOBAL THROUGH BINDING, INDIVIDUAL ARBITRATION
          RATHER THAN IN COURT. PLEASE REVIEW CAREFULLY SECTION ‎18 “DISPUTE
          RESOLUTION” BELOW FOR DETAILS REGARDING ARBITRATION.
        </b>
      </p>

      <div>
        <p>
          <b>1. Agreement to Terms.</b> By using the Services, you agree to be
          bound by these Terms and those detailed in our Privacy Policy. If you
          don’t agree to be bound by these Terms, you are not authorized to use
          the Services. By registering with, accessing, or otherwise using this
          website, you hereby agree to be bound by these Terms and Conditions
          set forth below. The mere use of this website implies the knowledge
          and acceptance of these Terms and conditions. In some particular
          cases, we can also ask you to explicitly agree.
        </p>
      </div>
      <div>
        <p>
          <b>2. Changes to these Terms or the Services.</b> We may update the
          Terms from time to time at our sole discretion. If we do, we’ll let
          you know by posting the updated Terms on the Site, to the Apps and/or
          may also send other communications. It is important that you review
          the Terms whenever we update them or you use the Services. If you
          continue to use the Services after we have posted updated Terms, it
          means that you accept and agree to the changes. If you don’t agree to
          be bound by the changes, you may not use the Services anymore. Because
          the Services are evolving over time, we may change or discontinue all
          or any part of the Services, at any time and without notice, at our
          sole discretion.{" "}
        </p>
      </div>

      <div>
        <p>
          <b>3. Accessibility.</b> We are committed to making the content we
          provide accessible to individuals with disabilities. If you have a
          disability and are unable to access any portion of our website due to
          your disability, we ask you to give us a notice including a detailed
          description of the issue you encountered. If the issue is readily
          identifiable and resolvable in accordance with industry-standard
          information technology tools and techniques we will promptly resolve
          it.
        </p>
      </div>
      <div>
        <p>
          <b>4. Who May Use the Services?</b>
        </p>
        <ul className="letter-order">
          <li>
            <b>
              Eligibility. YOU MAY USE THE SERVICES ONLY IF YOU ARE 18 YEARS OR
              OLDER AND CAPABLE OF FORMING A BINDING CONTRACT WITH REXLA GLOBAL,
              AND NOT OTHERWISE BARRED FROM USING THE SERVICES UNDER APPLICABLE
              LAW. THE SERVICES ARE NOT AVAILABLE TO RESIDENTS OF THE UNITED
              STATES.
            </b>{" "}
            We will not knowingly solicit or collect personal information from
            any user under the age of 13. Do not attempt to use the Services if
            you are under the age of 13. If we become aware that a user is under
            the age of 13, we will promptly delete all personal information of
            the user. If you have information that suggests that a user of the
            Service could be under the age of 13, please send an email to{" "}
            <a href="mailto:Compliance@rexla.com">Compliance@rexla.com</a>.
          </li>
          <li>
            <b>Compliance.</b> The Services are only available to users in
            certain jurisdictions who can use the Services as permitted under
            applicable law. You certify that you will comply with all applicable
            laws) when using the Services. Without limiting the foregoing, by
            using the Services, you represent and warrant to Rexla that neither
            you nor, where applicable, your beneficial owners and controllers
            are: (a) the subject of economic or trade sanctions administered or
            enforced by any governmental authority or otherwise designated on
            any list of prohibited or restricted parties (including the United
            Kingdom's Office of Financial Sanctions Implementation, or (b) a
            citizen, resident, or entity organised in a jurisdiction or
            territory that is the subject of comprehensive sanctions by the
            United Kingdom. You are solely responsible for ensuring that your
            access and use of the Services in such country, territory or
            jurisdiction does not violate any applicable laws. You must not use
            any software or networking techniques, including use of a Virtual
            Private Network (VPN) to modify your internet protocol address or
            otherwise circumvent or attempt to circumvent this prohibition. We
            reserve the right, but have no obligation, to monitor where the
            Services are accessed from. Furthermore, we reserve the right, at
            any time, at our sole discretion, to block access to the Services,
            in whole or in part, from any geographic location, IP addresses and
            unique device identifiers or to any user who we believe is in breach
            of these Terms.
          </li>
          <li>
            <b>Unauthorized Access.</b> You may not access or utilize the Site
            and/or Services for the purpose of web crawling, web harvesting,
            data mining, data extraction, scraping or aggregating information,
            including without limitation listings and smart contracts available
            on or through the Site and/or Services, or similar activities
            without our prior written consent at our sole discretion. We reserve
            the right to implement testing and maintenance of the API at our
            sole discretion. Engaging in any of the activities referenced in the
            first sentence of this paragraph without prior authorization is a
            prohibited material breach of these Terms and may subject violators
            to legal liability.
          </li>
        </ul>
      </div>

      <div>
        <p>
          <b>5. About the Services.</b>
        </p>
        <ul className="letter-order">
          <li>
            <b>Rexla Hub:</b> The Services facilitate interactions with Crypto
            Assets and blockchain protocols to allow individuals to begin
            exploring this new sector. These include Non Custodial Wallets,
            access to Dex protocols (Decentralised Exchanges) Educational
            content, Social Media.
            <ul className="roman-order">
              <li>
                You may participate in the Services by linking your Rexla
                Wallet,or a 3rd party external digital wallet(s) on supported
                bridge extensions, which allows you to purchase, store, and
                engage in transactions using cryptocurrency.{" "}
              </li>
              <li>
                REXLA GLOBAL IS NOT A BROKER, FINANCIAL INSTITUTION, OR
                CREDITOR. THE SERVICES ARE AN ADMINISTRATIVE PLATFORM ONLY,
                DESIGNED TO CONNECT USERS TO SERVICES.{" "}
              </li>
              <li>
                YOU BEAR FULL RESPONSIBILITY FOR ANY TRANSACTIONS MADE VIA YOUR
                OWN WALLETS, WHEN USING REXLA GLOBALS SERVICES.
              </li>
            </ul>
          </li>
          <li>
            <b>Transactions Are Conducted on the Blockchain.</b> While Rexla
            Global offers blockchain education and affiliate introductions to
            various services, it does not buy, sell, transfer or act as an agent
            or custodian for any user of the Services. You will be required to
            make or receive payments exclusively through the cryptocurrency
            wallet you have connected to the Rexla Hub. We will have no insight
            into or control over these payments or transactions, nor do we have
            the ability to reverse any transactions. Accordingly, we will have
            no liability to you or to any third party for any claims or damages
            that may arise as a result of any transactions that you engage in
            via our Services.
            <ul className="roman-order">
              <li>
                <b>Costs and Fees.</b> Transactions on the Rexla Hub may be
                subject to fees that Rexla Global collects to maintain services.
                This may be by way of a subscription, or a via a transaction
                based fee. You further agree to pay all other applicable fees,
                including Gas Fees and hosting fees, and you authorize Rexla to
                automatically charge you for any such fees or deduct such fees
                (including the Transaction Fee) directly from the amounts paid
                by the Purchaser or the amount received by Seller, at our
                discretion. “Gas fees” mean fees that fund the network of
                computers that run decentralized blockchain networks, meaning
                that you will need to pay a Gas Fee for each transaction that
                occurs via a blockchain network.
              </li>
            </ul>
          </li>
          <li>
            <b>Terms Applicable to the Software.</b> Use of the Software is
            governed by these Terms. Rexla delivers the Software via download
            and we will not provide you with any tangible copy of the Software.
            Subject to your compliance with the Terms, Rexla grants you a
            non-assignable, non-transferable, non-sublicensable, revocable, and
            non-exclusive license to use the Software on computers or mobile
            devices you own or control solely for your personal or internal
            business purposes.{" "}
            <b>
              Because the Software is locally installed, you are responsible for
              the security of the device on which it is installed, including
              ensuring that you keep anti-virus software current and otherwise
              protect the device on which the Software is installed against
              malware. You are responsible for securely maintaining any
              passwords or secret phrases that relate to your use of the
              Software. You acknowledge that certain methods of securing a
              secret recovery phrase, such as storing it as a digital file on
              your personal device or on a cloud storage provider, may increase
              the risk that your account or secret recovery phrase will be
              compromised. You further acknowledge that Rexla is not responsible
              for any theft of a secret recovery phrase, or loss or damages –
              including loss of funds or lockout from accounts accessed via the
              Software – resulting from your failure to keep the device on which
              the Software is installed safe and free of any malware. Rexla will
              not be able to recover passwords or unlock account information.
              This includes if the Software is compromised by malware on your
              computer, and it is your sole responsibility to take all
              reasonable precautions to secure and backup your copy of the
              Software and the information stored on it.
            </b>
          </li>
          <li>
            <b>Updates.</b> The Software and Services are evolving and you may
            be required to accept or install updates to the Software or
            Services, or update third-party software (i.e., browsers or OS) in
            order to keep using the Software or Services or access their latest
            features, including security updates. We may update the Software and
            Services at any time, without providing notice. It is your
            responsibility to ensure that you are using the most recent version
            of the Software at all times.
          </li>
          <li>
            <b>Terms Applicable to the “Digi Dimes” Rewards Program.</b> Rexla
            offers an off chain rewards program to users of our Services (the “
            <b>Digi Dimes</b>”). The Rewards Program is offered at our sole
            discretion. These terms, as well as rules, conditions, benefits or
            digital representations of your membership and participation in the
            Rewards Program (“<b>Rewards</b>”) may be modified at any time by
            Rexla with or without notice. Such changes may affect previously
            earned Rewards.
            <ul className="roman-order">
              <li>
                <b>Eligibility and Enrolment.</b> The Rewards Program is open to
                individuals who are eligible or choose to use the Services. The
                Rewards Program is intended for personal use only. Commercial
                use is prohibited. Users are automatically enrolled in the
                Rewards Program upon commencement of usage of the services.
              </li>
              <li>
                <b>How to Earn Rewards.</b> You may accumulate Rewards for any
                qualifying transaction made on and after your date of enrollment
                in the Rewards Program. The number and type of Rewards you can
                earn will be dependent on a particular promotion, action or
                other experience in connection with the Services. We reserve the
                right to retroactively award Rewards not meeting these
                conditions at our sole discretion. Rewards may be subject to
                additional terms, conditions, restrictions or limitations, which
                may be disclosed in conjunction with the opportunity to earn or
                redeem the Rewards, and such terms may be added to these Rewards
                Terms from time to time.
              </li>
              <li>
                <b>Tracking Rewards.</b> Rewards Program participants can view
                and track qualifying transactions via a dedicated section of
                their profile page on Rexla.com.
              </li>
              <li>
                <b>Using your Rewards and Special Offers.</b> We may from time
                to time at our sole discretion make available to participants in
                the Rewards Program the opportunity to earn, use or redeem
                Rewards through special offers, challenges, bonuses, or other
                promotions. The terms and conditions applicable to any such
                special offers, challenges, bonuses or other promotions will be
                determined by us at our sole discretion and communicated to
                participants in conjunction with any such offers in connection
                with the Services. Because any terms and conditions associated
                with any special offers, challenges, bonuses or other
                promotions, whether under the Rewards Program or as part of
                standalone promotion or product offering, may be different from
                or in addition to provisions of these Terms, you should read any
                such special offer terms and conditions carefully before
                participating in any special offer.
              </li>
              <li>
                <b>Limitations, Restrictions, and Other Terms.</b> Rexla’s
                determinations of participant eligibility or any questions or
                disputes arising under the Rewards Program shall be final and
                binding and not subject to challenge or appeal. Other than as
                set forth in the Dispute Resolution section of these Terms,
                nothing will limit Rexla from exercising any legal or equitable
                rights or remedies that it may have. Without notice to you,
                Rexla reserves the right to suspend and/or terminate any aspect
                of the Rewards Program and/or your participation in the Rewards
                Program if we determine at our sole discretion that you have
                violated these Terms, or that the use of the Rewards Program is
                unauthorized, deceptive, fraudulent, unlawful, or intentionally
                subverts the purposes of these Terms. In the event that your
                participation in the Rewards Program is terminated, then all
                accumulated Rewards may be voided at our discretion. There are
                no membership fees associated with the Rewards Program, although
                use of online services in conjunction with participation in the
                Rewards Program may result in data charges, internet access fees
                or similar expenses.
                <br />
                Rexla reserves the right to modify, amend or revise the Rewards
                that are made available. The number of Rewards required for
                redemption may be increased, any prize may be withdrawn, and
                restrictions on any prize or its redemption may be imposed by
                Rexla. Rexla is not responsible for any problems or technical
                malfunction of any telephone network or lines, computer online
                systems including blockchain systems, servers, or providers,
                computer equipment, software, failure of any e-mail as a result
                of technical problems or traffic congestion on the Internet or
                at any website, or any combination thereof, including, without
                limitation, any resulting error in computing qualifying
                transactions or any unavailability of Rewards, or any injury or
                damage to any participant's or any other person's computer or
                mobile device related to or resulting from participation in the
                Rewards Program. If, for any reason, the Rewards Program is not
                capable of running as planned, including due to errors of any
                kind or nature, infection by computer virus, bugs, tampering,
                unauthorized intervention, fraud, technical failures, or any
                other causes beyond the control of Rexla which corrupt or affect
                the administration, security, fairness, integrity or proper
                conduct of the Rewards Program,Rexla reserves the right at its
                sole discretion to cancel, terminate, modify, or suspend the
                Rewards Program or otherwise respond to the circumstances as we
                deem appropriate.
              </li>
              <li>
                <b>Changes to the Rewards Program.</b> Rexla reserves the right
                to change, update and/or discontinue, in whole or in part,
                either temporarily or permanently, the Rewards Program or any
                portion of the Rewards Program, all or any portion of these
                Terms, and/or any policy, FAQ, guidelines or disclosures
                pertaining to the Rewards Program, at any time at its sole
                discretion and without advance notice to you or any other
                participants. Unless otherwise specified, any changes or
                modifications will be effective immediately upon posting
                revisions to our Terms, and you waive any right you may have to
                receive specific notice of such changes or modifications. If you
                continue to participate in the Rewards Program by earning
                Rewards and redeeming your Rewards, or otherwise participating
                in the Rewards Program in any way after a change to these Terms,
                you will be deemed to have read, understood and unconditionally
                consented and agreed to such changes. Rexla will not be liable
                to you in the event of any modification, suspension or
                discontinuance of the Rewards Program.
              </li>
              <li>
                <b>Taxes.</b> You are solely responsible for all costs incurred
                by you in using the Services and determining, collecting,
                reporting and paying all applicable Taxes. As used herein, “
                <b>Taxes</b>” means the taxes, duties, levies, tariffs, and
                other governmental charges that you may be required by law to
                collect and remit to governmental agencies, other similar
                withholdings, and personal or corporate income taxes. You are
                solely responsible for maintaining all relevant Tax records and
                complying with any reporting requirements you may have as
                related to the Services. You are further solely responsible for
                independently maintaining the accuracy of any record submitted
                to any tax authority including any information derived from the
                Services. We reserve the right to report any activity occurring
                using the Services to relevant tax authorities as required under
                applicable law.
              </li>
              <li>
                <b>Suspension or Termination.</b> We may suspend or terminate
                your access to the Services at any time in connection with any
                transaction as required by applicable law, any governmental
                authority, or if we at our sole and reasonable discretion
                determine you are violating these Terms or the terms of any
                third-party service provider. Such suspension or termination
                shall not constitute a breach of these Terms by Rexla. In
                accordance with our anti-money laundering, anti-terrorism,
                anti-proliferation financing, anti-fraud, sanctions and other
                compliance policies and practices, we may impose reasonable
                limitations and controls on the ability of you or any
                beneficiary to utilize the Services. Such limitations may
                include where good cause exists, rejecting transaction requests,
                freezing funds, or otherwise restricting you from using the
                Services.
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div>
        <p>
          <b>
            <b>6. Feedback.</b> We appreciate feedback, comments, ideas,
            proposals and suggestions for improvements to the Services (“
            <b>Feedback</b>”). If you choose to submit Feedback, you agree that
            we are free to use it without any restriction or compensation to
            you.
          </b>
        </p>
      </div>

      <div>
        <p>
          <b>7. Your Content.</b>
        </p>

        <p>
          <b>Posting Content.</b> The Services may allow you to store or share
          content such as text (in posts or communications with others), files,
          documents, graphics, images, music, software, audio and video.
          Anything (other than Feedback) that you post or otherwise make
          available through the Services is referred to as “<b>User Content</b>
          ”. User Content may include NFT Content. Rexla does not claim any
          ownership rights in any User Content and nothing in these Terms will
          be deemed to restrict any rights that you may have to your User
          Content. This is fully documented in the “
          <b>Xyra Platform Terms of Service</b>”
        </p>
        <p>
          <b>App License.</b> If you comply with these Terms, Rexla grants to
          you a limited non-exclusive, non-transferable license, with no right
          to sublicense, to download and install Apps on your personal
          computers, mobile handsets, tablets, wearable devices, and/or other
          devices and to run Apps solely for your own personal non-commercial
          purposes. Except as expressly permitted in these Terms, you may not:
          (i) copy, modify or create derivative works based on the Apps; (ii)
          distribute, transfer, sublicense, lease, lend or rent the Apps to any
          third party; (iii) reverse engineer, decompile or disassemble the Apps
          (unless applicable law permits, despite this limitation); or (iv) make
          the functionality of the App available to multiple users through any
          means.
        </p>
      </div>

      <div>
        <p>
          <b>
            <b>8. Acceptable Use Policy and Rexla’s Enforcement Rights.</b> You
            agree not to do any of the following:
          </b>
        </p>
        <ul className="letter-order">
          <li>
            Post, upload, publish, submit or transmit any User Content that: (i)
            infringes, misappropriates or violates a third party’s patent,
            copyright, trademark, trade secret, moral rights or other
            intellectual property rights, or rights of publicity or privacy;
            (ii) violates, or encourages any conduct that would violate, any
            applicable law or regulation or would give rise to civil liability;
            (iii) is fraudulent, false, misleading or deceptive; (iv) is
            defamatory; (v) promotes discrimination, bigotry, racism, hatred,
            harassment or harm against any individual or group; (vi) is violent
            or threatening or promotes violence or actions that are threatening
            to any person or entity; or (vii) promotes illegal or harmful
            activities or substances;
          </li>
          <li>
            Use, display, mirror or frame the Services or any individual element
            within the Services, Rexla’s name, any Rexla trademark, logo or
            other proprietary information, or the layout and design of any page
            or form contained on a page, without Rexla’s express written
            consent;
          </li>
          <li>
            Access, tamper with, or use non-public areas of the Services,
            Rexla’s computer systems, or the technical delivery systems of
            Rexla’s providers;
          </li>
          <li>
            Attempt to probe, scan or test the vulnerability of any Rexla system
            or network or breach any security or authentication measures;
          </li>
          <li>
            Avoid, bypass, remove, deactivate, impair, descramble or otherwise
            circumvent any technological measure implemented by Rexla or any of
            Rexla’s providers or any other third party (including another user)
            to protect the Services;
          </li>
          <li>
            Attempt to access or search the Services or download content from
            the Services using any engine, software, tool, agent, device or
            mechanism (including spiders, robots, crawlers, data mining tools or
            the like) other than the software and/or search agents provided by
            Rexla or other generally available third-party web browsers;
          </li>
          <li>
            Send any unsolicited or unauthorized advertising, promotional
            materials, email, junk mail, spam, chain letters or other form of
            solicitation;
          </li>
          <li>
            Use the Services, or any portion thereof, for any commercial purpose
            or for the benefit of any third party or in any manner not permitted
            by these Terms;
          </li>
          <li>
            Forge any TCP/IP packet header or any part of the header information
            in any email or newsgroup posting, or in any way use the Services to
            send altered, deceptive or false source-identifying information;
          </li>
          <li>
            Attempt to decipher, decompile, disassemble or reverse engineer any
            of the software used to provide the Services;
          </li>
          <li>
            Interfere with, or attempt to interfere with, the access of any
            user, host or network, including, without limitation, sending a
            virus, overloading, flooding, spamming, or mail-bombing the
            Services;
          </li>
          <li>
            Collect or store any personally identifiable information from the
            Services from other users of the Services without their express
            permission; .Impersonate or misrepresent your affiliation with any
            person or entity;
          </li>
          <li>
            Engage or assist in any activity that violates any law, statute,
            ordinance, regulation, or sanctions program, including but not
            limited to sanctions lists maintained by the United Nations, United
            Kingdom, or that involves proceeds of any unlawful activity
            (including but not limited to money laundering, terrorist financing,
            proliferation financing or deliberately engaging in activities
            designed to adversely affect the performance of the Services);
          </li>
          <li>
            Use the Services to participate in fundraising for a business,
            protocol, or platform, including but not limited to creating,
            listing, or buying assets that are redeemable for financial
            instruments, assets that give owners the rights to participate in
            any securities offering, or assets that entitle owners to financial
            rewards, including but not limited to, DeFi (or decentralized
            finance) yield bonuses, staking bonuses, and burn discounts;
          </li>
          <li>
            Fabricate in any way any transaction or process related thereto;
          </li>
          <li>
            Disguise or interfere in any way with the IP address of the computer
            you are using to access or use the Services or that otherwise
            prevents us from correctly identifying the IP address of the
            computer you are using to access the Services;
          </li>
          <li>
            Transmit, exchange, or otherwise support the direct or indirect
            proceeds of criminal or fraudulent conduct or activity;
          </li>
          <li>Violate any applicable law or regulation; or</li>
          <li>
            Encourage or enable any other individual to do any of the foregoing.
          </li>
        </ul>
        <p>
          Rexla is not obligated to monitor access to or use of the Services or
          to review or edit any content. However, we have the right to do so for
          the purpose of operating the Services, to ensure compliance with these
          Terms and to comply with applicable law or other legal requirements.
          We reserve the right, but are not obligated, to remove or disable
          access to any content, including User Content, at any time and without
          notice, including, but not limited to, if we, at our sole discretion,
          consider it objectionable or in violation of these Terms. We have the
          right to investigate violations of these Terms or conduct that affects
          the Services. We may also consult and cooperate with law enforcement
          authorities to prosecute users who violate the law. The sale of stolen
          assets, assets taken without authorization, and otherwise illegally
          obtained assets on the Service is prohibited. If you have reason to
          believe that an asset listed on the Service was illegally obtained,
          please contact us immediately. Listing illegally obtained assets may
          result in your listings being canceled, your assets being hidden, or
          you being suspended from the Services.
        </p>
      </div>

      <div>
        <p>
          <b>9. Copyright Policy.</b> Rexla respects copyright law and expects
          its users to do the same. It is Rexla’s policy to terminate in
          appropriate circumstances users who infringe or are believed to be
          repeatedly infringing the rights of copyright holders.{" "}
        </p>
      </div>

      <div>
        <p>
          <b>10. Links to Third Party Websites or Resources.</b> The Services
          (including the Apps) may allow you to access third-party websites or
          other resources. We provide access only as a convenience and are not
          responsible for the content, products or services on or available from
          those resources, websites, or links displayed on such resources or
          websites. You acknowledge sole responsibility for and assume all risk
          arising from your use of any third-party resources or websites.
        </p>
      </div>

      <div>
        <p>
          <b>11. Termination.</b> Notwithstanding anything contained in these
          Terms, we may suspend, modify or terminate your access to and use of
          the Services and the applicability of these Terms at our sole
          discretion, at any time and without notice to you. You may disconnect
          your digital wallet at any time. You acknowledge and agree that we
          shall have no liability or obligation to you in such an event and that
          you will not be entitled to a refund of any amounts that you have
          already paid to us or any third party, to the fullest extent permitted
          by applicable law.{" "}
        </p>
      </div>

      <div>
        <p>
          <b>12. Warranty Disclaimers.</b> THE SERVICES, INCLUDING THE SOFTWARE,
          PROMOTIONS TOOL, ANY CONTENT CONTAINED THEREIN ARE PROVIDED ON AN “AS
          IS” AND “AS AVAILABLE” BASIS WITHOUT WARRANTIES OR CONDITIONS OF ANY
          KIND, EITHER EXPRESS OR IMPLIED. REXLA (AND ITS SUPPLIERS) MAKE NO
          WARRANTY THAT THE SERVICES: (I) WILL MEET YOUR REQUIREMENTS; (II) WILL
          BE AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE BASIS;
          OR (III) WILL BE ACCURATE, RELIABLE, COMPLETE, LEGAL, OR SAFE. REXLA
          DISCLAIMS ALL OTHER WARRANTIES OR CONDITIONS, EXPRESS OR IMPLIED,
          INCLUDING, WITHOUT LIMITATION, INCLUDING ANY IMPLIED WARRANTY OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT OR
          NON-INFRINGEMENT, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW,
          AS TO THE SERVICES AND ANY CONTENT CONTAINED THEREIN.
        </p>
        <p>
          WE FURTHER EXPRESSLY DISCLAIM ALL LIABILITY OR RESPONSIBILITY IN
          CONNECTION WITH THIRD PARTY SERVICES. NOTHING HEREIN NOR ANY USE OF
          THE SERVICES IN CONNECTION WITH THIRD PARTY SERVICES CONSTITUTES OUR
          ENDORSEMENT, RECOMMENDATION OR ANY OTHER AFFILIATION OF OR WITH ANY
          THIRD PARTY SERVICES.
        </p>
        <p>
          REXLA DOES NOT REPRESENT OR WARRANT THAT ANY CONTENT ON THE SERVICES
          IS ACCURATE, COMPLETE, RELIABLE, CURRENT OR ERROR-FREE. WE WILL NOT BE
          LIABLE FOR ANY LOSS OF ANY KIND FROM ANY ACTION TAKEN OR TAKEN IN
          RELIANCE ON MATERIAL OR INFORMATION CONTAINED ON THE SERVICES. WHILE
          REXLA ATTEMPTS TO MAKE YOUR ACCESS TO AND USE OF THE SERVICES AND ANY
          CONTENT THEREIN SAFE, REXLA CANNOT AND DOES NOT REPRESENT OR WARRANT
          THAT THE SERVICES, ANY CONTENT THEREIN, ANY NFTS LISTED THEREIN, OR
          OUR SERVERS ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. WE CANNOT
          GUARANTEE THE SECURITY OF ANY DATA THAT YOU DISCLOSE ONLINE. YOU
          ACCEPT THE INHERENT SECURITY RISKS OF PROVIDING INFORMATION AND
          DEALING ONLINE OVER THE INTERNET AND WILL NOT HOLD US RESPONSIBLE FOR
          ANY BREACH OF SECURITY.
        </p>
        <p>
          REXLA WILL NOT BE RESPONSIBLE OR LIABLE TO YOU FOR ANY LOSS AND TAKES
          NO RESPONSIBILITY FOR, AND WILL NOT BE LIABLE TO YOU FOR, ANY USE OF
          THE SERVICES, INCLUDING BUT NOT LIMITED TO ANY LOSSES, DAMAGES OR
          CLAIMS ARISING FROM: (I) USER ERROR SUCH AS FORGOTTEN PASSWORDS,
          INCORRECTLY CONSTRUCTED TRANSACTIONS, OR MISTYPED WALLET ADDRESSES;
          (II) SERVER FAILURE OR DATA LOSS; (III) BLOCKCHAIN NETWORKS,
          CRYPTOCURRENCY WALLETS OR CORRUPT FILES; (IV) UNAUTHORIZED ACCESS TO
          SERVICES; OR (V) ANY THIRD PARTY ACTIVITIES, INCLUDING WITHOUT
          LIMITATION THE USE OF VIRUSES, PHISHING, BRUTEFORCING OR OTHER MEANS
          OF ATTACK.
        </p>
        <p>
          THE SERVICES MAY NOT BE AVAILABLE DUE TO ANY NUMBER OF FACTORS
          INCLUDING, BUT NOT LIMITED TO, PERIODIC SYSTEM MAINTENANCE, SCHEDULED
          OR UNSCHEDULED, ACTS OF GOD, UNAUTHORIZED ACCESS, VIRUSES, DENIAL OF
          SERVICE OR OTHER ATTACKS, TECHNICAL FAILURE OF THE SERVICES AND/OR
          TELECOMMUNICATIONS INFRASTRUCTURE OR DISRUPTION, AND THEREFORE WE
          EXPRESSLY DISCLAIM ANY EXPRESS OR IMPLIED WARRANTY REGARDING THE USE
          AND/OR AVAILABILITY, ACCESSIBILITY, SECURITY OR PERFORMANCE OF THE
          SERVICES CAUSED BY SUCH FACTORS. WE DO NOT MAKE ANY REPRESENTATIONS OR
          WARRANTIES AGAINST THE POSSIBILITY OF DELETION, MISDELIVERY OR FAILURE
          TO STORE COMMUNICATIONS, PERSONALIZED SETTINGS OR OTHER DATA.
        </p>
        <p>
          <b>
            SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES.
            ACCORDINGLY, SOME OF THE ABOVE DISCLAIMERS OF WARRANTIES MAY NOT
            APPLY TO YOU.
          </b>
        </p>
      </div>

      <div>
        <p>
          <b>13. Assumption of Risk.</b> You accept and acknowledge:
        </p>
        <ul className="letter-order">
          <li>
            You are solely responsible for determining what, if any, Taxes apply
            to your transactions through the Services. Neither Rexla nor any
            Rexla affiliates are responsible for determining the Taxes that
            apply to such transactions.
          </li>
          <li>
            Any transfer of cryptocurrency assets occurs within the supporting
            Blockchain and not on the Services. Transactions may be
            irreversible, and, accordingly, losses due to fraudulent or
            accidental transactions may not be recoverable. Some transactions
            shall be deemed to be made when recorded on a public ledger, which
            is not necessarily the date or time that you initiated the
            transaction.
          </li>
          <li>
            There are risks associated with using a Crypto currency, including
            but not limited to, the risk of hardware, software and Internet
            connections, the risk of malicious software introduction, and the
            risk that third parties may obtain unauthorized access to
            information stored within your wallet. You accept and acknowledge
            that Rexla will not be responsible for any communication failures,
            disruptions, errors, distortions or delays you may experience when
            using the Services for transactions, however caused.
          </li>
          <li>
            The regulatory regime governing blockchain technologies,
            cryptocurrencies, and tokens is uncertain, and new regulations or
            policies may materially adversely affect the development of the
            Services.
          </li>
          <li>
            The Services may rely on third-party platforms to perform
            transactions with respect to any cryptocurrency assets. If we are
            unable to maintain a good relationship with such platform providers;
            if the terms and conditions or pricing of such platform providers
            change; if we violate or cannot comply with the terms and conditions
            of such platforms; or if any of such platforms loses market share or
            falls out of favor or is unavailable for a prolonged period of time,
            access to and use of the Service will suffer.
          </li>
          <li>
            There are risks associated with purchasing user generated content,
            including but not limited to, the risk of purchasing counterfeit
            assets, mislabeled assets, assets that are vulnerable to metadata
            decay, assets on smart contracts with bugs, and assets that may
            become untransferable. Rexla reserves the right to hide collections,
            contracts, and assets affected by any of these issues or by other
            issues. Assets you purchase may become inaccessible on Rexla. Under
            no circumstances shall the inability to view or access your assets
            on Rexla serve as grounds for a claim against Rexla.
          </li>
          <li>
            By accessing and using the Services, you represent to Rexla that you
            understand the inherent risks associated with using cryptographic
            and blockchain-based systems, and that you have a working knowledge
            of digital assets. Such systems may have vulnerabilities or other
            failures, or other abnormal behavior. Rexla is not responsible for
            any issues with the Blockchains or other blockchain-based networks,
            including forks, technical node issues or any other issues having
            fund, NFT, or Rewards losses as a result. You acknowledge that the
            cost and speed of transacting with cryptographic and
            blockchain-based systems are variable and may increase at any time.
            You further acknowledge the risk that your digital assets may lose
            some or all of their value while they are supplied to or from the
            Services. You further acknowledge that we are not responsible for
            any of these variables or risks and cannot be held liable for any
            resulting losses that you experience while accessing Services.
            Accordingly, you understand and agree to assume full responsibility
            for all of the risks of accessing and using and interacting with the
            Services.
          </li>
        </ul>
      </div>

      <div>
        <p>
          <b>14. Indemnity.</b>
        </p>
        <ul className="letter-order">
          <li>
            You will indemnify and hold Rexla and its officers, directors,
            employees and agents, harmless from and against any and all claims,
            disputes, demands, liabilities, damages, losses, and costs and
            expenses (including, without limitation, reasonable legal and
            accounting fees) arising out of or in any way connected with (a)
            your access to or use of the Services, (b) your violation of these
            Terms. You may not settle or otherwise compromise any claim subject
            to this Section without Rexla’s prior written approval.
          </li>
          <li>
            You will indemnify and hold harmless Rexla and its officers,
            directors, employees and agents, from and against any claims,
            disputes, demands, liabilities, damages, losses, and costs and
            expenses, including, without limitation, reasonable legal and
            accounting fees arising out of or in any way connected with your
            breach of your representations and warranties from Section 5(e)(v).
          </li>
        </ul>
      </div>

      <div className="">
        <p>
          <b>15. Limitation of Liability.</b>
        </p>
        <ul className="letter-order">
          <li>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, REXLA SHALL NOT BE LIABLE
            FOR ANY INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES, OR
            DAMAGES FOR LOST PROFITS, LOST REVENUES, LOST SAVINGS, LOST BUSINESS
            OPPORTUNITY, LOSS OF DATA OR GOODWILL, SERVICE INTERRUPTION,
            COMPUTER DAMAGE OR SYSTEM FAILURE OR THE COST OF SUBSTITUTE SERVICES
            OF ANY KIND ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OR FROM
            THE USE OF OR INABILITY TO USE THE SERVICES, WHETHER BASED ON
            WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY,
            OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT REXLA OR ITS SERVICE
            PROVIDERS HAVE BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE.
          </li>
        </ul>
      </div>

      <div>
        <p>
          <b>General Terms.</b>
        </p>
        <ul className="letter-order">
          <li>
            <b>Reservation of Rights.</b> Rexla and its licensors exclusively
            own all rights, title and interest in and to the Services, including
            all associated intellectual property rights. You acknowledge that
            the Services are protected by copyright, trademark, and other laws.
            You agree not to remove, alter or obscure any copyright, trademark,
            service mark or other proprietary rights notices incorporated in or
            accompanying the Services.
          </li>
          <li>
            <b>Disclosures.</b> You acknowledge and agree that there may be
            circumstances that arise (including related to your purchase or
            selling activities on the Site) which may create actual or potential
            conflicts of interests between your interests and others’ interests,
            including the interests of other users, counterparties, or Rexla. We
            maintain a conflicts of interest policy to assist its handling of
            any actual or potential conflicts of interests. If there are
            circumstances where there is an actual or potential conflict of
            interest between yourself and Rexla, We will take reasonable steps
            to ensure you are treated fairly. You acknowledge and agree that
            Rexla and our affiliates have discretion to maintain commercial
            relationships with third parties (including liquidity providers or
            executing dealers). Such third parties may transact with you on any
            purchase or sale activities by you, and Rexla and/or our affiliates
            may derive financial and other benefits from such relationships.
          </li>
          <li>
            <b>Severability.</b> If an arbitrator or court of competent
            jurisdiction decides that any part of these Terms is invalid or
            unenforceable, the other parts of these Terms will still apply.
          </li>
          <li>
            <b>Entire Agreement.</b> These Terms constitute the entire and
            exclusive understanding and agreement between Rexla and you
            regarding the Services, and these Terms supersede and replace all
            prior oral or written understandings or agreements between Rexla and
            you regarding the Services. If any provision of these Terms is held
            invalid or unenforceable by an arbitrator or a court of competent
            jurisdiction, that provision will be enforced to the maximum extent
            permissible, and the other provisions of these Terms will remain in
            full force and effect. Except where provided by applicable law in
            your jurisdiction, you may not assign or transfer these Terms, by
            operation of law or otherwise, without Rexla's prior written
            consent. Any attempt by you to assign or transfer these Terms absent
            our consent or your statutory right, without such consent, will be
            null. Rexla may freely assign or transfer these Terms without
            restriction. Subject to the foregoing, these Terms will bind and
            insure to the benefit of the parties, their successors and permitted
            assigns.
          </li>
          <li>
            <b>Notices.</b> Except as otherwise set forth in Section 18(a), any
            notices or other communications provided by Rexla under these Terms
            will be given: (i) via email; or (ii) by posting to the Services.
            For notices made by email, the date of receipt will be deemed the
            date on which such notice is transmitted.
          </li>
          <li>
            <b>Waiver of Rights.</b> Rexla’s failure to enforce any right or
            provision of these Terms will not be considered a waiver of such
            right or provision. The waiver of any such right or provision will
            be effective only if in writing and signed by a duly authorized
            representative of Rexla.
          </li>
          <p>
            Except as expressly set forth in these Terms, the exercise by either
            party of any of its remedies under these Terms will be without
            prejudice to its other remedies under these Terms or otherwise.
          </p>
        </ul>

        <p>
          <b>Contact Information.</b> If you have any questions about these
          Terms or the Services, please contact Rexla via the contact details
          provided at Rexla.com
        </p>
        <p>
          <b>Data Protection.</b> We subscribe to a high level of data
          protection and security. This is fully detailed within our{" "}
          <Link to="/privacy-policy" target="_blank">
            <b>Privacy Policy</b>
          </Link>{" "}
          Any personal data that we collect (or is collected by third parties on
          our behalf) will be processed in accordance with this document.
        </p>
        <p>
          <b>Third Party Rights.</b> Except as expressly provided in Section 15,
          a person who is not a party to these Terms shall not have any rights
          under the Contracts (Rights of Third Parties) Act (as amended) to
          enforce any term of these Terms. Notwithstanding any term of these
          Terms, the consent of or notice to any person who is not a party to
          these Terms shall not be required for any termination, rescission or
          agreement to any variation, waiver, assignment, novation, release or
          settlement under these Terms at any time.
        </p>
      </div>

      <div>
        <h5>Choice of Law and Jurisdiction</h5>
        <p>
          These Terms and Conditions shall be governed by the laws of United
          Arab Emirates. Any disputes relating to these Terms and Conditions
          shall be subject to the jurisdiction of the courts of United Arab
          Emirates. If any part or provision of these Terms and Conditions is
          found by a court or other authority to be invalid and/or unenforceable
          under applicable law, such part or provision will be modified, deleted
          and/or enforced to the maximum extent permissible so as to give effect
          to the intent of these Terms and Conditions. The other provisions will
          not be affected.
        </p>
      </div>

      <div>
        <h5>Contact information</h5>
        <p>This website is owned and operated by Rexla Global L.L.C - FZ.</p>
        <p>
          You may contact us regarding these Terms and Conditions by writing or
          emailing us at the following address:{" "}
          <a href="mailto:webmaster@rexla.com">webmaster@rexla.com</a>
          <p>
            Business Center 1, M Floor, The Meydan Hotel, Nad Al Sheba, Dubai,
            U.A.E
          </p>
        </p>
        <p>
          You can also{" "}
          <a
            href="https://rexlaglobal.com/wp-content/plugins/complianz-terms-conditions/download.php"
            target="_blank"
            rel="noreffer"
          >
            download
          </a>
          our Terms and Conditions as a PDF.
        </p>
      </div>
    </div>
  );
};

export default Terms;
